import React, { Fragment } from "react";
import PageContainer from "../../../components/page-container/PageContainer";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { Loading } from "../../../components/loading/Loading";
import {
  Button,
  ButtonGroup,
  Grid,
  Checkbox
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createObjectives, getObjectives, deleteObjectives } from "../../../state/actions/ObjectiveActions";
import SimpleTable from "../../../components/table/Table";
import Search from "../../../components/search/Search";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import { NewObjectiveDialog } from "./new-objective-dialog/NewObjectiveDialog";
import { UUID } from "../../../helpers/uuid";
import { getUser } from "../../../config/azureConfig";
import styles from "./ListObjectivesPage.module.scss";
import { withTranslation } from "react-i18next";
import { ObjectiveType } from "../../../state/constants/ObjectiveConstants";

class ListObjectivesPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      originalData: [],
      searchedData: [],
      selectedObjectives: [],
      objectives: props.objectives,
      newFormModalOpen: false
    };
  }

  componentDidMount() {
    this.setupData();
  }

  componentWillUnmount() {
    // this.props.setNewFormTitle("", () => { })
  }

  componentDidUpdate() {
    if (JSON.stringify(this.state.objectives) !== JSON.stringify(this.props.objectives)) {
      const data = Object.keys(this.props.objectives).map(objectiveid => {
        return this.props.objectives[objectiveid];
      });

      this.setState({
        originalData: data,
        searchedData: data,
        objectives: this.props.objectives
      });
    }
  }

  setupData() {
    this.setState({ loading: true });
    this.getObjectives([ObjectiveType().admin.key, ObjectiveType().admin_route.key]);
  }

  getObjectives() {
    this.props.getObjectives([ObjectiveType().admin.key, ObjectiveType().admin_route.key], () => {
      const data = Object.keys(this.props.objectives).map(objectiveid => {
        return this.props.objectives[objectiveid];
      });

      this.setState({
        loading: false,
        searchedData: data,
        originalData: data
      });
    });
  }

  createHeaders() {
    return [
      {
        id: "Title",
        clickable: true,
        action: { path: "/objectives/{id}", identifier: "id" },
        align: "left",
        label: this.props.t('objective.title')
      },
      {
        id: "Description",
        clickable: false,
        align: "left",
        label: this.props.t('common.description')
      },
      {
        id: "CreatedAt",
        clickable: false,
        align: "left",
        label: this.props.t('common.created-at')
      },
      {
        id: "DueTime",
        clickable: false,
        align: "left",
        label: this.props.t('common.due-at')
      },
      {
        id: "ObjectiveType",
        clickable: false,
        align: "left",
        label: this.props.t('common.type'),
        type: "tag",
        color: "green"
      },
      {
        id: "UserId",
        clickable: false,
        align: "left",
        label: this.props.t('user.user-id'),
      },
      {
        id: "Active",
        clickable: false,
        align: "left",
        label: this.props.t('common.active'),
        type: "tag",
        color: "green"
      },
    ];
  }

  createCells(headers) {
    let cells = [];

    headers.forEach(header => {
      let cell = { id: header.id };

      if (header.hasOwnProperty("action")) {
        cell.handleClick = (event, row) => {
          let path = header.action.path.replace(
            "{id}",
            row[header.action.identifier]
          );
          this.props.history.push(path);
        };
      }

      cell.align = header.align;
      cell.clickable = header.clickable;
      cell.type = header.type;
      cell.color = header.color;

      cells.push(cell);
    });

    return cells;
  }

  renderList() {
    const headers = this.createHeaders();
    const cells = this.createCells(headers);

    return (
      <SimpleTable
        handleSelection={selectedIds => {
          var objectives = selectedIds.map((id) => this.props.objectives[id]);
          this.setState({ selectedObjectives: objectives });
        }}
        dataId={"id"}
        headers={headers}
        cells={cells}
        isSelectable={true}
        rows={this.state.searchedData}
      />
    );
  }

  alertDialog() {
    return (
      <AlertDialog
        title={this.props.t("common.remove-question")}
        description={this.props.t("common.remove-description")}
        options={[
          {
            label: this.props.t('common.cancel'),
            action: () => this.setState({ deleteAlertShowing: false })
          },
          { label: this.props.t('common.delete'), action: () => this.handleDelete() }
        ]}
        isOpen={this.state.deleteAlertShowing}
      />
    );
  }

  handleDelete() {
    this.props.deleteObjectives(this.state.selectedObjectives, () => {
      this.setState({ deleteAlertShowing: false, selectedObjectives: [] });
      this.setupData()
    });
  }

  newFormDialog() {
    return (
      <NewObjectiveDialog
        dialogTitle={this.props.t('objective.create-new')}
        confirmLabel={this.props.t('common.create')}
        onCancel={() => {
          const url = this.props.match.path;
          this.setState({ newFormModalOpen: false, editObjectiveId: null });
          this.props.history.push(url);
        }}
        onConfirm={(objectiveDetails) => {
          const user = getUser();

          let dueTime = objectiveDetails.dueTime;
          let expirationDate = objectiveDetails.expirationDate;
          let completeInCall = objectiveDetails.completeInCall;

          if (dueTime != null && dueTime != undefined) {
            dueTime = dueTime.toISOString();
          }

          if (expirationDate != null && expirationDate != undefined) {
            expirationDate = expirationDate.toISOString();
          }

          var objective = {
              "id": UUID(),
              "UserId": user.profile.oid,
              "UserType": "admin",
              "ObjectiveType": objectiveDetails.objectiveType,
              "SubType": objectiveDetails.subType,
              "CustomSubType": true,
              "ObjectiveKey": "admin",
              "CustomerId": null,
              "Title": objectiveDetails.title,
              "Description": objectiveDetails.description,
              "CreatedAt": (new Date()).toISOString(),
              "ExpirationDate": expirationDate,
              "CompleteInCall": completeInCall,
              "DueTime": dueTime,
              "Complete": false,
              "Active": true
          }

          this.props.createObjectives([objective], () => {
            this.setState({ newFormModalOpen: false, editObjectiveId: null })
          });
        }}

        isOpen={this.state.newFormModalOpen}
        title={this.props.currentForm != null ? this.props.currentForm.Name : ""}
      />
    )
  }

  render() {
    return (
      <Fragment>
        {this.alertDialog()}
        <HeaderBlock
          title={this.props.t('objective.objectives')}
          right={
            <Grid container spacing={2} alignItems="center" justify="flex-end">
              <Grid item>
                <Search
                  searchField={"Title"}
                  secondaryFields={["id"]}
                  returnSearchMatches={data => {
                    this.setState({ searchedData: data });
                  }}
                  data={this.state.originalData}
                  searchTitle={this.props.t('objective.search')}
                />
              </Grid>
              <Grid item>
                <ButtonGroup>
                  <Button
                    disabled={this.state.selectedObjectives.length === 0}
                    onClick={() => this.setState({ deleteAlertShowing: true })}
                    variant="outlined"
                    color="primary"
                  >
                    {this.props.t('common.delete')}
                  </Button>
                  <Button
                    onClick={() =>
                      this.setState({ newFormModalOpen: true })
                    }
                    variant="outlined"
                    color="secondary"
                  >
                    {this.props.t('objective.new')}
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          }
        />
        {this.newFormDialog()}
        <PageContainer hasFooter>
          {this.state.loading ? <Loading /> : this.renderList()}
        </PageContainer>
      </Fragment>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { objectives } = state.ObjectivesReducer;
  return { objectives };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createObjectives, getObjectives, deleteObjectives }, dispatch);

const hoc = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListObjectivesPage))
);

// EXPORT COMPONENT
export { hoc as ListObjectivesPage };
